import React, { useCallback } from 'react';
import { Checkbox } from 'ncoded-component-library';
import { FieldRenderProps } from 'react-final-form';
import { ExtractPropTypes } from '../../../types';
import classNames from 'classnames';
import { isEnterPressed } from 'utils';

import './CheckboxField.styles.scss';

type CheckboxProps = ExtractPropTypes<typeof Checkbox> & {
  styled?: boolean;
  customOnChange?: (
    value: boolean | React.ChangeEvent<HTMLInputElement>,
  ) => void;
};

type CheckboxFieldProps = FieldRenderProps<string, HTMLElement> & CheckboxProps;

const CheckboxField: React.FC<CheckboxFieldProps> = (props): JSX.Element => {
  const {
    styled,
    className,
    disabled,
    id,
    input: { checked, onChange, ...restInput },
    meta: { error, touched },
    customOnChange,
    ...rest
  } = props;

  const classes = classNames(className, {
    'ncoded-checkbox--checked': styled && checked,
    'ncoded-checkbox--styled': styled,
    'ncoded-checkbox--error': error && touched,
  });

  const onChangeHandler = useCallback(() => {
    if (disabled) return;

    onChange(!checked);
    customOnChange?.(!checked);
  }, [checked, disabled, customOnChange, onChange]);

  return (
    <div
      id={id}
      className="res-checkbox-field"
      tabIndex={0}
      onKeyPress={(e) => {
        if (isEnterPressed(e)) {
          onChangeHandler();
        }
      }}
    >
      <Checkbox
        className={classes}
        checked={checked}
        disabled={disabled}
        onChange={onChangeHandler}
        {...restInput}
        {...rest}
      />
      {error && touched && <small>{error}</small>}
    </div>
  );
};

export default CheckboxField;
